'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DataTable: ()=>DataTable
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../Pagination/index.cjs");
const external_Table_index_cjs_namespaceObject = require("../Table/index.cjs");
const external_DataTableControls_cjs_namespaceObject = require("./DataTableControls.cjs");
const external_DataTBody_cjs_namespaceObject = require("./DataTBody.cjs");
const external_DataTHead_cjs_namespaceObject = require("./DataTHead.cjs");
const DataTable = ({ table, ...tableProps })=>{
    const { columnSizing, rowSelection } = table.getState();
    const resize = (0, external_react_namespaceObject.useMemo)(()=>{
        if (table.options.enableColumnResizing) return true;
        return Boolean(table.getAllColumns().find((column)=>column.columnDef.enableResizing));
    }, [
        table
    ]);
    const columnSizeVars = (0, external_react_namespaceObject.useMemo)(()=>{
        if (!resize) return {};
        const headers = table.getFlatHeaders();
        const colSizes = {};
        for(let i = 0; i < headers.length; i++){
            const header = headers[i];
            colSizes[`--header-${header.id}-size`] = header.getSize() + 'px';
            colSizes[`--col-${header.column.id}-size`] = header.column.getSize() + 'px';
        }
        return {
            ...colSizes,
            minWidth: table.getTotalSize() + 'px'
        };
    }, [
        table,
        columnSizing,
        resize
    ]);
    const showPagination = (0, external_react_namespaceObject.useMemo)(()=>{
        if (table.options.manualPagination || -1 === table.getPageCount()) return true;
        return table.getPageCount() > 0 && void 0 !== table.options.getPaginationRowModel;
    }, [
        table
    ]);
    const handleRowsPerPageChange = (0, external_react_namespaceObject.useCallback)((rowsPerPage)=>{
        table.setPageSize(rowsPerPage);
    }, [
        table
    ]);
    const handlePageChange = (0, external_react_namespaceObject.useCallback)((pageIndex)=>{
        table.setPageIndex(pageIndex - 1);
    }, [
        table
    ]);
    const hasColumnFilters = (0, external_react_namespaceObject.useMemo)(()=>{
        if (!table.options.enableColumnFilters) return false;
        if (table.options.manualFiltering) return true;
        return table.getAllColumns().some((column)=>column.getCanFilter());
    }, [
        table
    ]);
    const hasControls = (0, external_react_namespaceObject.useMemo)(()=>table.options.enableGlobalFilter || hasColumnFilters, [
        hasColumnFilters,
        table.options.enableGlobalFilter
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        children: [
            hasControls && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataTableControls_cjs_namespaceObject.DataTableControls, {
                table: table,
                hasColumnFilters: true
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "no-scrollbar overflow-auto",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Table_index_cjs_namespaceObject.Table, {
                    style: {
                        ...columnSizeVars
                    },
                    cellWordBreak: table.options.enableColumnResizing ? 'breakAll' : 'breakNormal',
                    ...tableProps,
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataTHead_cjs_namespaceObject.DataTHead, {
                            table: table
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataTBody_cjs_namespaceObject.MemoizedTBody, {
                            table: table,
                            rowCount: table.getRowCount(),
                            rowSelection: rowSelection,
                            columns: table.getAllColumns()
                        })
                    ]
                })
            }),
            showPagination && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Pagination, {
                className: "mt-4",
                variant: "advanced",
                rowsPerPageOptions: table.options.meta?.rowsPerPageOptions,
                initialRowsPerPage: table.getState().pagination.pageSize,
                currentPage: table.getState().pagination.pageIndex + 1,
                onRowsPerPageChange: handleRowsPerPageChange,
                totalRows: table.getRowCount(),
                onPageChange: handlePageChange
            })
        ]
    });
};
exports.DataTable = __webpack_exports__.DataTable;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DataTable"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
